import { gql } from '@apollo/client';
import { DealFragment } from '../fragments/DealFragment';
/**
 * Public API update deal (response excludes internalNotes).
 * @const UpdateDealPublicMutation
 * @since 1.0.0
 */
export const UpdateDealPublicMutation = gql `
  mutation UpdateDealPublicMutation($input: UpdateDealInput!) {
    updateDeal(input: $input) {
      ...DealFragment
    }
  }

  ${DealFragment}
`;
